var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgErrorIcon = function SvgErrorIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9AD5CF",
    fillRule: "nonzero",
    d: "M16.838 0c.67 0 1.215.56 1.215 1.25L18 14c0 .191-16 .69-16 0 .005-2.275.008-4.153.009-5.635V7.11h5.042c.991 0 1.457-.467 1.396-1.4V.963C8.447 0 9.042 0 9.341 0zM12.5 11h-5a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1zm4 0h-2a.5.5 0 1 0 0 1h2a.5.5 0 1 0 0-1zm-4-3h-5a.5.5 0 0 0 0 1h5a.5.5 0 1 0 0-1zm4 0h-2a.5.5 0 1 0 0 1h2a.5.5 0 1 0 0-1zm-4.319-4H10.5a.5.5 0 1 0 0 1h1.681a.5.5 0 1 0 0-1zM15.5 4h-1a.5.5 0 1 0 0 1h1a.5.5 0 1 0 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA5DE6",
    d: "M2 14h16v6H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9AD5CF",
    d: "M6.44 0v3.976c-.138.676-.355.888-1.021 1.024H2l4.44-5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f00",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "error-icon.1ead2fccca6719489b00a7c19b8dacdd.svg";